import { OFFERFIT_PIPELINE_TYPES } from "./constants";

/**
 * Pro agents are managed by the BrazeAI Decisioning Studio team and are read-only in the
 * dashboard (ADX-1101). Strictly PRO: unknown or missing types remain editable by design.
 */
export const isReadOnlyUseCase = (pipelineType?: string): boolean => pipelineType === OFFERFIT_PIPELINE_TYPES.PRO;
